import { loaderAction, setCashAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";

export const getCashThunk = (args) => async (dispatch, getState) => {
    const { user } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('date_from', args.date_from);
        formData.append('date_to', args.date_to);
        formData.append('payment_method', args.payment_method);

        const response = await api({ data: formData, link: 'get_cash_list' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            dispatch(setCashAction(response.cash));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        dispatch(loaderAction(false));
    }
    finally {
        dispatch(loaderAction(false));
    }
};